/** @format */

import angular from 'angular';
import angularMoment from 'angular-moment';
import NgPokie from 'ng-pokie';
import 'ng-pokie/dist/ngPokie.css';

import { ItemModelsModule } from 'crowdcomms-js/lib/galabid/item/models';
import { ItemActivityModelsModule } from 'crowdcomms-js/lib/galabid/item-activity/models';
import { LabelsModule } from 'crowdcomms-js/lib/ui/labels';
import { ProjectorModelsModule } from 'crowdcomms-js/lib/galabid/projector/models';
import { HonourRollModelsModule } from 'crowdcomms-js/lib/galabid/honour-roll/models';
import { ToastModule } from 'crowdcomms-js/lib/ui/toast';

import { SharedComponentsModule } from '@galabid-presenter/shared/components';

import { GbWidgetComponent } from './gb-widget/gb-widget.component.js';
import { GbTextWidgetComponent } from './gb-text-widget/gb-text-widget.component.js';
import { GbImageWidgetComponent } from './gb-image-widget/gb-image-widget.component.js';
import { GbItemTableWidgetComponent } from './gb-item-table-widget/gb-item-table-widget.component.js';
import { GbTotalRaisedWidgetComponent } from './gb-total-raised-widget/gb-total-raised-widget.component.js';
import { GbThermometerWidgetComponent } from './gb-thermometer-widget/gb-thermometer-widget.component.js';
import { GbNotificationWidgetComponent } from './gb-notification-widget/gb-notification-widget.component.js';
import { GbNotificationPopoutAComponent } from './gb-notification-popout-a/gb-notification-popout-a.component.js';
import { GbNotificationPopoutBComponent } from './gb-notification-popout-b/gb-notification-popout-b.component.js';
import { GbNotificationToastAComponent } from './gb-notification-toast-a/gb-notification-toast-a.component.js';
import { GbTableItemComponent } from './gb-table-item/gb-table-item.component.js';
import { GbTableItemCompactComponent } from './gb-table-item-compact/gb-table-item-compact.component.js';
import { GbTableItemStandardComponent } from './gb-table-item-standard/gb-table-item-standard.component.js';
import { GbTableItemTallCardComponent } from './gb-table-item-tall-card/gb-table-item-tall-card.component.js';
import { GbBiddingItemAmountComponent } from './gb-bidding-item-amount/gb-bidding-item-amount.component.js';
import { GbBiddingItemAmountLabelComponent } from './gb-bidding-item-amount-label/gb-bidding-item-amount-label.component.js';
import { GbDonationItemAmountComponent } from './gb-donation-item-amount/gb-donation-item-amount.component.js';
import { GbDonationItemAmountLabelComponent } from './gb-donation-item-amount-label/gb-donation-item-amount-label.component.js';
import { GbRaffleItemAmountComponent } from './gb-raffle-item-amount/gb-raffle-item-amount.component.js';
import { GbRaffleItemAmountLabelComponent } from './gb-raffle-item-amount-label/gb-raffle-item-amount-label.component.js';
import { GbPurchaseItemAmountComponent } from './gb-purchase-item-amount/gb-purchase-item-amount.component.js';
import { GbPurchaseItemAmountLabelComponent } from './gb-purchase-item-amount-label/gb-purchase-item-amount-label.component.js';
import { GbRaffleDrawWidgetComponent } from './gb-raffle-draw-widget/gb-raffle-draw-widget.component.js';
import { GbRaffleWinnersWidgetComponent } from './gb-raffle-winners-widget/gb-raffle-winners-widget.component.js';
import { GbRaffleWidgetItemNameComponent } from './gb-raffle-widget-item-name/gb-raffle-widget-item-name.component.js';
import { GbCountdownWidgetComponent } from './gb-countdown-widget/gb-countdown-widget.component.js';
import { GbTeamScoringWidgetComponent } from './gb-team-scoring-widget/gb-team-scoring-widget.component.js';
import { GbBelowReserveBadgeComponent } from './gb-below-reserve-badge/gb-below-reserve-badge.component.js';
import { GbHonourRollWidgetComponent } from './gb-honour-roll-widget/gb-honour-roll-widget.component.js';
import { GbProfileHonourRollComponent } from './gb-profile-honour-roll/gb-profile-honour-roll.component.js';

export const WidgetComponentsModule = angular
    .module('galabid-presenter.components.widget.components', [
        NgPokie,
        ItemModelsModule,
        ItemActivityModelsModule,
        LabelsModule,
        ProjectorModelsModule,
        HonourRollModelsModule,
        ToastModule,
        SharedComponentsModule,
        angularMoment,
    ])
    .component('gbWidget', GbWidgetComponent)
    .component('gbTextWidget', GbTextWidgetComponent)
    .component('gbImageWidget', GbImageWidgetComponent)
    .component('gbItemTableWidget', GbItemTableWidgetComponent)
    .component('gbTotalRaisedWidget', GbTotalRaisedWidgetComponent)
    .component('gbThermometerWidget', GbThermometerWidgetComponent)
    .component('gbNotificationWidget', GbNotificationWidgetComponent)
    .component('gbNotificationPopoutA', GbNotificationPopoutAComponent)
    .component('gbNotificationPopoutB', GbNotificationPopoutBComponent)
    .component('gbNotificationToastA', GbNotificationToastAComponent)
    .component('gbTableItem', GbTableItemComponent)
    .component('gbTableItemCompact', GbTableItemCompactComponent)
    .component('gbTableItemStandard', GbTableItemStandardComponent)
    .component('gbTableItemTallCard', GbTableItemTallCardComponent)
    .component('gbBiddingItemAmount', GbBiddingItemAmountComponent)
    .component('gbBiddingItemAmountLabel', GbBiddingItemAmountLabelComponent)
    .component('gbDonationItemAmount', GbDonationItemAmountComponent)
    .component('gbDonationItemAmountLabel', GbDonationItemAmountLabelComponent)
    .component('gbRaffleItemAmount', GbRaffleItemAmountComponent)
    .component('gbRaffleItemAmountLabel', GbRaffleItemAmountLabelComponent)
    .component('gbPurchaseItemAmount', GbPurchaseItemAmountComponent)
    .component('gbPurchaseItemAmountLabel', GbPurchaseItemAmountLabelComponent)
    .component('gbRaffleDrawWidget', GbRaffleDrawWidgetComponent)
    .component('gbRaffleWinnersWidget', GbRaffleWinnersWidgetComponent)
    .component('gbRaffleWidgetItemName', GbRaffleWidgetItemNameComponent)
    .component('gbCountdownWidget', GbCountdownWidgetComponent)
    .component('gbTeamScoringWidget', GbTeamScoringWidgetComponent)
    .component('gbBelowReserveBadge', GbBelowReserveBadgeComponent)
    .component('gbHonourRollWidget', GbHonourRollWidgetComponent)
    .component('gbProfileHonourRoll', GbProfileHonourRollComponent)
    .constant('moment', require('moment-timezone')).name;
